function buildPath(name) {
  return `/_assets/apps/common/${name}.mp3`;
}

export const CLICK = buildPath('click');

export const CORRECT = buildPath('correct');

export const COURSE_COMPLETION = buildPath('course-completion');

export const INCORRECT = buildPath('incorrect');

export const RECALL = buildPath('recall');

export const DONE = buildPath('done');

export const WELCOME = buildPath('welcome');

export const TIMEOUT = buildPath('timeout');

export const TYPING = buildPath('typing');

export const RAPID_CHOICE_CORRECT = buildPath('rapid_choice_correct');

export const RAPID_CHOICE_INCORRECT = buildPath('rapid_choice_incorrect');

export const SPELL_CORRECT = buildPath('spell_correct');

export const SPELL_INCORRECT = buildPath('spell_incorrect');

export const ACHIEVEMENT = buildPath('achievement');

export const CHECKPOINT = buildPath('checkpoint');
